var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.document ? _c('timeline-card', {
    attrs: {
      "id": _vm.document ? _vm.document.id : 'document',
      "loading": _vm.isLoading,
      "title": _vm.title
    },
    scopedSlots: _vm._u([{
      key: "menu",
      fn: function fn() {
        return [_vm.$vuetify.breakpoint.smAndDown ? _c('context-menu', [_c('Can', {
          attrs: {
            "I": _vm.ActionEnum.READ,
            "a": _vm.ResourceEnum.DOCUMENT,
            "field": _vm.document.partnerId
          }
        }, [_c('v-list-item', {
          on: {
            "click": function click($event) {
              _vm.openSideCard = true;
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("timeLine.ActivityTimeLineItemTicket.detail")) + " ")])], 1), _vm.document ? _c('file-download', {
          attrs: {
            "downloadFiles": [_vm.downloadFile],
            "listItem": true
          }
        }) : _vm._e(), _vm.activityLogEntry ? _c('activity-time-line-item-delete', {
          attrs: {
            "text": true,
            "partnerId": _vm.activityLogEntry.partnerId,
            "activityId": _vm.activityLogEntry.id
          }
        }) : _vm._e()], 1) : _c('div', {
          staticStyle: {
            "display": "flex",
            "align-items": "center"
          }
        }, [_c('Can', {
          attrs: {
            "I": _vm.ActionEnum.READ,
            "a": _vm.ResourceEnum.DOCUMENT,
            "field": _vm.document.partnerId
          }
        }, [_c('v-btn', {
          staticClass: "mt-n1",
          attrs: {
            "x-small": "",
            "outlined": "",
            "color": "info",
            "disabled": !_vm.document
          },
          on: {
            "click": function click($event) {
              _vm.openSideCard = true;
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("timeLine.ActivityTimeLineItemTicket.detail")) + " ")])], 1), _vm.document ? _c('file-download', {
          attrs: {
            "downloadFiles": [_vm.downloadFile],
            "icon": true
          }
        }) : _vm._e(), _vm.activityLogEntry ? _c('activity-time-line-item-delete', {
          attrs: {
            "partnerId": _vm.activityLogEntry.partnerId,
            "activityId": _vm.activityLogEntry.id
          }
        }) : _vm._e()], 1)];
      },
      proxy: true
    }], null, false, 1269711630)
  }, [_c('v-card-subtitle', [_vm._v(" " + _vm._s(_vm.document.title) + " ")]), _vm.document.description ? _c('v-card-subtitle', {
    staticClass: "mt-n8"
  }, [_vm._v(" " + _vm._s(_vm.document.description) + " ")]) : _vm._e(), _vm.document ? _c('activity-time-line-item-document-card-images', {
    attrs: {
      "document": _vm.document
    }
  }) : _vm._e(), _vm.openSideCard ? _c('sign-document-side-card', {
    on: {
      "close": function close($event) {
        _vm.openSideCard = false;
      }
    },
    model: {
      value: _vm.document,
      callback: function callback($$v) {
        _vm.document = $$v;
      },
      expression: "document"
    }
  }) : _vm._e()], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }